import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectUser, selectBookingsHistory } from '../../../store';
import useGetEvents from './use-get-events';

export const useAppConfiguration = () => {
  const { user, loading: userLoading } = useSelector(selectUser);
  const location = useLocation();
  const { bookings, loading, fetched } = useSelector(selectBookingsHistory);

  const { isLoading, recommendationBox } = useGetEvents();

  const recommendationParam = new URLSearchParams(location.search).get(
    'product_assessment_completed',
  );

  const withUnlimitedCredits = user?.subscription?.type === 'UNLIMITED';
  const withSideNavigation = !location.pathname.includes('assessment');
  const withCredits = !location.pathname.includes('assessment');
  const withNavbarLogo = !location.pathname.includes('assessment');
  const withLogoutBtn = !location.pathname.includes('assessment');

  // Show Product Assessment when user doesn't have a
  // booking and has not complete the Product assessment
  const showProductAssessment =
    !loading &&
    !userLoading &&
    bookings.length === 0 &&
    !user?.lastAssessment.PRODUCT_RECOMMENDATION;

  const showRecommendations =
    (!isLoading &&
      fetched &&
      recommendationBox.length > 0 &&
      user?.lastAssessment.PRODUCT_RECOMMENDATION &&
      bookings.length === 0) ||
    recommendationParam;

  const showDismissRecommendations =
    !isLoading &&
    recommendationBox?.length === 0 &&
    user?.lastAssessment.PRODUCT_RECOMMENDATION &&
    bookings.length === 0;

  return {
    withSideNavigation,
    withCredits,
    withNavbarLogo,
    withLogoutBtn,
    withUnlimitedCredits,
    showProductAssessment,
    showRecommendations,
    showDismissRecommendations,
  };
};
